module.exports = __webpack_public_path__ + "img/project_bg_white.30356403.png";